import React, { useContext, useState } from 'react';
import { sendPostMessage } from '../../Utils/postMessage';
import { VehicleApplicationContext } from '../../VehicleApplicationContext/WithVehicleApplicationContext';
import AmountPart3 from '../AmountPart3/AmountPart3';
import { Context } from '../Context/withContext';
import LandingSection from '../LandingSection/LandingSection';
import Loader from '../LoaderSpinner/LoaderSpinner';
import { PathContext } from '../PathContext/PathContext';
import RequestError from '../RequestError/RequestError';
import Steps from '../Steps/Steps';
import VehiclePart6 from '../VahiclePart6/VehiclePart6';
import VehiclePart1 from '../VehiclePart1/VehiclePart1';
import VehiclePart2 from '../VehiclePart2/VehiclePart2';
import VehiclePart3 from '../VehiclePart3/VehiclePart3';
import VehiclePart4 from '../VehiclePart4/VehiclePart4';
import VehiclePart5 from '../VehiclePart5/VehiclePart5';

const Form = () => {
  const [stepNumber] = useContext(Context);
  const [path] = useContext(PathContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [vehicleApplication, setVehicleApplication] = useContext(
    VehicleApplicationContext,
  );

  React.useEffect(() => {
    window.onload = () => sendPostMessage();
    window.onresize = () => sendPostMessage();
  }, []);

  React.useEffect(() => {
    sendPostMessage();
  }, [stepNumber]);

  const getFormSection = () => {
    if (stepNumber === 0) {
      return <LandingSection />;
    }

    let comp;

    if (path === 'v') {
      switch (stepNumber) {
        case 1:
          return <VehiclePart1 />;
        case 2:
          return <VehiclePart2 />;
        case 3:
          return (
            <VehiclePart3
              loadng={loading}
              setLoading={setLoading}
              setError={setError}
            />
          );
        case 4:
          return <VehiclePart4 />;
        case 5:
          return (
            <VehiclePart5
              loadng={loading}
              setLoading={setLoading}
              setError={setError}
            />
          );
        case 6:
          return <VehiclePart6 />;

        default:
          break;
      }
    } else if (path === 'a') {
      switch (stepNumber) {
        case 1:
          return <VehiclePart2 />;
        case 2:
          return (
            <VehiclePart3
              loadng={loading}
              setLoading={setLoading}
              setError={setError}
            />
          );
        case 3:
          return <AmountPart3 />;
        case 4:
          return (
            <VehiclePart1
              loadng={loading}
              setLoading={setLoading}
              setError={setError}
            />
          );
        case 5:
          return (
            <VehiclePart4
              loadng={loading}
              setLoading={setLoading}
              setError={setError}
            />
          );
        case 6:
          return (
            <VehiclePart5
              loadng={loading}
              setLoading={setLoading}
              setError={setError}
            />
          );
        case 7:
          return <VehiclePart6 />;

        default:
          break;
      }
    }

    return comp;
  };

  return (
    <div className="bg-black fastapp m-auto p-10 w-full">
      <div className="md:border border-suzGreen">
        {vehicleApplication ? (
          <div className="my-16 md:w-1/2 mx-auto text-white flex flex-col md:flex-row gap-6 items-center justify-center">
            <p className="text-3xl tracking-widest uppercase">
              Application for {vehicleApplication}
            </p>
            <div>
              <img
                className="w-1/2 mx-auto md:w-full"
                alt=""
                src={vehicleApplication.thumbnail}
              />
            </div>
          </div>
        ) : (
          <div className="md:p-8 p-4"></div>
        )}
        {loading ? <Loader /> : error ? <RequestError /> : getFormSection()}
        {/* <VehiclePart5 /> */}
        <div className="mt-12">
          {stepNumber ? (
            <Steps number={path === 'v' ? 6 : 7} active={stepNumber} />
          ) : null}
        </div>
        <div className="md:px-44 py-8">
          <p className="text-center ">
            Experiencing technical issues? Please complete this form and someone
            will be in contact soon, alternatively reach out to your closest
            dealer to help you with your application.
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <button
              className="px-8 py-3 cursor-pointer mt-8 border-suzGreen border-2 text-suzGreen bg-transparent hover:bg-suzBlue hover:text-white transition-all duration-150"
              onClick={() => {
                window.open(
                  'https://share.hsforms.com/1u1x-h4hOQiGsWWPDwM9WWg1d35r',
                  '_blank',
                );
              }}
            >
              Get a dealer to contact me
            </button>
            <button
              className="px-8 py-3 cursor-pointer mt-8 border-suzGreen border-2 text-suzGreen bg-transparent hover:bg-suzBlue hover:text-white transition-all duration-150"
              onClick={() => {
                window.open(
                  'https://share.hsforms.com/1owIWs3uRREqLoHWqB9gBkg1d35r',
                  '_blank',
                );
              }}
            >
              Experiencing technical issues?
            </button>
          </div>
        </div>
        <span
          onClick={() => {
            window.open('https://www.suzukiauto.co.za/terms-and-conditions');
          }}
          className="text-white underline cursor-pointer font-medium text-center block my-12 hover:text-suzGreen transition-all duration-150"
        >
          Terms & Conditions
        </span>
      </div>
    </div>
  );
};

export default Form;
